<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a href="/admin/adminInvoice/">Invoices</a></li>
      <li class="breadcrumb-item active" aria-current="page">Payment Status</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-2">
      <div class="col">
        <div class="inner-box">
          <div class="text-center">
            <h2 class="text-black mb-3 review">Payment Confirmation</h2>
          </div>
          <div class="row">
            <div class="col-8">
              <div class="row mt-4">
                <div class="col-6">
                  <label class="text-black"><b>Invoice Number : </b>{{pay.invoiceNum}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Invoice Date : </b>{{pay.invoiceDate}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Invoice Amount : </b>{{pay.totalAmount}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>External Reference Number : </b>{{pay.paymentRefNumber}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Notes : </b>{{pay.comments}}</label>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Payment Mode
                    : </b>{{(pay.paymentType == 'BANK_TRANSFER' ? 'Bansk Transfer' :
                    (pay.paymentType == 'CHEQUE' ? 'Cheque' :
                      (pay.paymentType == 'CASH' ? 'Cash' : "")))}}</label><br>
                </div>
                <div class="col-6">
                  <label class="text-black"><b>Payment Reference Number : </b>{{pay.refNumber}}</label><br>
                </div>
              </div>
            </div>
            <div class="col-4">
              <img class="d-md-none d-sm-none d-xs-none d-lg-block shift-uploaded-img" src="{{pay.referenceImage !=null ? pay.referenceImage : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"  width="150" height="150" />
              <img class="d-lg-none d-sm-none d-xs-none d-md-block shift-uploaded-img" src="{{pay.referenceImage !=null ? pay.referenceImage : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="150" height="150" />
              <img class="d-lg-none d-md-none d-xs-none d-sm-block shift-uploaded-img" src="{{pay.referenceImage !=null ? pay.referenceImage : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="100" height="100" />
              <img class="d-lg-none d-md-none d-sm-none d-xs-block shift-uploaded-img" src="{{pay.referenceImage !=null ? pay.referenceImage : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="50" height="50" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="col-md-4">
            <div class="required">
              <label for="description" style="font-size:11px">Comments</label>
              <textarea id="description" [(ngModel)]="comments" rows="4"  maxlength="250" class="form-control" [ngModelOptions]="{standalone: true}" required></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row text-right mt-3">
      <div class="col">
        <button *ngIf="user.role === 'ACCOUNT_OWNER'" type="button" routerLink="/admin/invoices" class="btn btn-cancel">Close</button>
        <button *ngIf="user.role === 'ROLE_ADMIN'" type="button" routerLink="/admin/adminInvoice" class="btn btn-cancel">Close</button>
        <button *ngIf="user.role === 'ACCOUNT_OWNER'" type="button" (click)="processingPayment()" class="btn btn-orange ml-2">Submit</button>
        <button *ngIf="user.role === 'ROLE_ADMIN'" type="button" (click)="processingPaymentAdmin()" class="btn btn-orange ml-2">Submit</button>
      </div>
    </div>
  </form>
</section>
